import React, { useEffect } from 'react'
import { App } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'
import packageJson from '../../../package.json';

const useAppInfo = () => {
  const [appInfoString, setAppInfoString] = React.useState('')
  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      App.getInfo().then((value) => {
        setAppInfoString(`Version: ${value.version}+${value.build}`)
      })
    } else {
      setAppInfoString(`Version: ${packageJson.version}+${packageJson.build}`)
    }
  }, [])

  return { appInfoString }
}

export default useAppInfo
